// extracted by mini-css-extract-plugin
export default {"tooltipWrapper":"hZ-z","tooltip":"iZ-z","tooltipContent":"jZ-z","orderStatusWrapper":"kZ-z"};